import { useTheme } from "@emotion/react";
import {
  Alert,
  Button,
  CircularProgress,
  Drawer,
  IconButton,
  Modal,
  Snackbar,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import useStyles from "./styles";

import { ArrowForwardIosOutlined, ClearOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import EditTicketComponentIxc from "../editTicketComponentIxc";

import InternoModalConfirmacaoSaida from "../../modalSaindoDaPagina";
import TicketModalContentIxc from "../detailsTicketIxcComponent";

export default function ModalNewTicketIxc(params) {
  const {
    open,
    handleClose = () => {},
    refrashTIckets = () => {},
    clienteErpId = null,
    serviceId = null,
    isOs = false,
  } = params;
  const [clientes, setClientes] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [loadingServicos, setLoadingServicos] = useState(false);
  const [loadingCreateTicket, setLoadingCreateTicket] = useState(false);
  const [dataTicket, setDataTicket] = useState({});
  const [loadingLogins, setLoadingLogins] = useState(false);
  const [loadingParams, setLoadingParams] = useState(false);
  const [logins, setLogins] = useState([]);
  const [filiais, setFiliais] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [setores, setSetores] = useState([]);
  const [prioridades, setPrioridades] = useState([]);
  const [prioridadesOs, setPrioridadesOs] = useState([]);
  const [assuntos, setAssuntos] = useState([]);
  const [status, setStatus] = useState([]);
  const [statusOs, setStatusOs] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [isNewTicket, setIsNewTicket] = useState(false);
  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
  const [isNewOs, setIsNewOs] = useState(false);
  const [isEditTicket, setIsEditTicket] = useState(false);
  const [itensPublic, setItensPublic] = useState({
    mensagens: [],
    anexos: [],
    rfo: [],
  });
  const [isEditOs, setIsEditOs] = useState(false);
  const [value, setValue] = useState(0);
  const [ticketDetails, setTicketDetails] = useState(null);
  const [snackbar, setSnackbar] = useState(null);
  const [error, setError] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);

  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP || "";
  const labelTabsErp = {
    descricao:
      erp === "HUBSOFT"
        ? "Descrição"
        : erp === "VOALLE"
          ? "Geral"
          : "Descrição",
    mensagens:
      erp === "HUBSOFT"
        ? "Mensagens"
        : erp === "VOALLE"
          ? "Histórico"
          : "Mensagens",
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setIsEditOs(false);
    setIsEditTicket(false);
  };
  useEffect(() => {
    if (open) {
      /*     setUsuariosSelecionados(
        JSON.parse(localStorage.getItem("usuariosResponsaveis")) || [],
      ); */
      setDataTicket((prev) => ({
        ...prev,
        usuariosResponsaveis:
          JSON.parse(localStorage.getItem("usuariosResponsaveis")) || [],
      }));
      getClientes();
      getParamsNewTicket();
    }
  }, [open]);

  useEffect(() => {
    if (clienteErpId) {
      const filter = clientes?.find(
        (item) => item?.clienteErpId === clienteErpId,
      );

      if (filter) {
        setDataTicket({
          ...dataTicket,
          nome: filter?.nome || null,
          cnpj: filter?.cnpj,
          clienteErpId: filter?.clienteErpId,
        });
      } else {
        setDataTicket({
          ...dataTicket,
          nome: null,
          cnpj: null,
          clienteErpId: null,
        });
      }
    }
  }, [clientes]);

  useEffect(() => {
    if (serviceId && dataTicket?.clienteErpId) {
      const filter = servicos?.find(
        (item) => item?.id_cliente_servico === serviceId,
      );

      if (filter) {
        setDataTicket({
          ...dataTicket,
          clienteServicoId: filter?.id_cliente_servico,
        });
      } else {
        setDataTicket({
          ...dataTicket,
          clienteServicoId: null,
        });
      }
    }
  }, [servicos, dataTicket?.clienteErpId, serviceId]);

  useEffect(() => {
    if (dataTicket?.cnpj) {
      getServicos();
    }
  }, [dataTicket?.cnpj]);

  useEffect(() => {
    if (dataTicket?.clienteServicoId) {
      /*  getInfoClientNewTicket(); */
      getLoginsIxc();
    }
  }, [dataTicket?.clienteServicoId]);

  const getLoginsIxc = async () => {
    setLoadingLogins(true);
    try {
      const response = await api.post("/interno/find/loginsIxc", {
        idContrato: dataTicket?.clienteServicoId,
      });
      setLogins(response?.data);
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
      setLoadingLogins(false);
    }
  };

  const getClientes = async () => {
    try {
      const response = await api.get("/interno/getClients");
      // Grupos econômicos não podem abrir tickets/OS — exclui das options
      setClientes(
        Array.isArray(response?.data)
          ? response.data.filter((cliente) => !cliente?.isGrupoEconomico)
          : [],
      );
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
    }
  };

  const closeModal = () => {
    if (loadingCreateTicket) return;
    handleClose();
    setDataTicket({});
    setConfirmacaoSaidaPagina(false);
    setError(false);
    setTicketDetails(null);
    setIsEditTicket(false);
    setIsEditOs(false);
    setIsNewOs(false);
    setIsNewTicket(false);

    //Caso tenha ocorrido um novo ticket, atualizar os tickets ao fechar o modal
    if (isNewTicket) {
      refrashTIckets();
      setIsNewTicket(false);
    }
  };

  const createTicket = async () => {
    if (
      !dataTicket?.clienteErpId ||
      !dataTicket?.clienteServicoId ||
      !dataTicket?.filialId ||
      !dataTicket?.endereco ||
      !dataTicket?.assuntoId ||
      !dataTicket?.departamentoId ||
      !dataTicket?.prioridadeId ||
      !dataTicket?.descricaoAbertura?.trim() ||
      !dataTicket?.statusId ||
      !dataTicket?.responsavelId
    ) {
      setSnackbar({
        severity: "warning",
        children: "Preencha todos os campos obrigatórios",
      });

      setError(true);
      return;
    }

    setError(false);
    setLoadingCreateTicket(true);

    const formData = new FormData();

    formData.append("dataTicketIXC", JSON.stringify(dataTicket));

    try {
      const response = await api.post("/interno/create/ticket", formData);
      setTicketDetails(response?.data);
      setIsNewTicket(true); //Estado para monitorar se ocorreu criação de novo ticket
    } catch (error) {
      console.error("Erro ao criar ticket:", error);
      setSnackbar({
        children: "Error: Erro ao criar atendimento",
        severity: "error",
      });
    } finally {
      setLoadingCreateTicket(false);
    }
  };
  const createOs = async () => {
    if (
      !dataTicket?.clienteErpId ||
      !dataTicket?.clienteServicoId ||
      !dataTicket?.filialId ||
      !dataTicket?.endereco ||
      !dataTicket?.assuntoId ||
      !dataTicket?.departamentoId ||
      !dataTicket?.prioridadeId ||
      !dataTicket?.descricaoAbertura?.trim() ||
      !dataTicket?.statusId ||
      !dataTicket?.responsavelId
    ) {
      setSnackbar({
        severity: "warning",
        children: "Preencha todos os campos obrigatórios",
      });

      setError(true);
      return;
    }

    setError(false);
    setLoadingCreateTicket(true);

    try {
      const response = await api.post("/interno/create/os", {
        dataOs: dataTicket,
      });
      setTicketDetails(response?.data);
      setIsNewTicket(true); //Estado para monitorar se ocorreu criação de novo ticket
    } catch (error) {
      console.error("Erro ao criar OS:", error);
      setSnackbar({
        children: "Error: Erro ao criar os",
        severity: "error",
      });
    } finally {
      setLoadingCreateTicket(false);
    }
  };
  const getParamsNewTicket = async () => {
    setLoadingParams(true);
    try {
      const response = await api.get("/interno/find/paramsNewTicket");

      setFiliais(response?.data?.filiais || []);
      setAssuntos(response?.data?.assuntos || []);
      setDepartamentos(response?.data?.departamentos || []);
      setSetores(response?.data?.setores || []);
      setPrioridades(response?.data?.prioridades || []);
      setPrioridadesOs(response?.data?.prioridadesOsIxc || []);
      setStatus(response?.data?.status || []);
      setStatusOs(response?.data?.statusOsIxc || []);
      setHorarios(response?.data?.horarios || []);
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
      setLoadingParams(false);
    }
  };
  const getServicos = async () => {
    try {
      setLoadingServicos(true);

      const response = await api.post("/interno/find/allServiceClient", {
        idClienteErp: dataTicket?.clienteErpId,
      });
      setServicos(response?.data);
    } catch (error) {
      console.error("Erro ao buscar serviços:", error);
    } finally {
      setLoadingServicos(false);
    }
  };

  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
  };

  const handleCloseConfirmation = () => {
    setConfirmacaoSaidaPagina(true);
  };

  return (
    <>
      {ticketDetails ? (
        <>
          <TicketModalContentIxc
            open={open}
            handleClose={closeModal}
            erp={erp}
            ticketDetails={ticketDetails}
            status={ticketDetails?.status}
            labelTabsErp={labelTabsErp}
            value={value}
            handleChange={handleChange}
            isEdit={true}
            setTicketDetails={setTicketDetails}
            itensPublic={itensPublic}
            setItensPublic={setItensPublic}
            setSnackbar={setSnackbar}
            isAtendimento={true}
            setIsEditTicket={setIsEditTicket}
            isEditTicket={isEditTicket}
            isOs={isOs}
            setIsNewOs={setIsNewOs}
            isNewOs={isNewOs}
            isEditOs={isEditOs}
            setIsEditOs={setIsEditOs}
          />
          <InternoModalConfirmacaoSaida
            openConfirmacao={confirmacaoSaidaPagina}
            confirmLoad={false}
            setOpenConfirmacao={setConfirmacaoSaidaPagina}
            execute={closeModal}
            cancel={handleCancelNavigation}
            severity={"warning"}
            title={"Atenção"}
            contentText={
              "As alterações não salvas serão perdidas, deseja continuar?"
            }
            headerText={"Você está prestes a sair do modo de edição."}
            confirmText={"Continuar"}
          />
        </>
      ) : (
        <Drawer
          anchor="right"
          open={open}
          onClose={handleCloseConfirmation}
          PaperProps={{
            sx: {
              width: "80%",
              maxWidth: "80%",
            },
          }}
        >
          <Box sx={styles.containerModal}>
            {loadingCreateTicket ? (
              <Box sx={styles.conatinerLoading}>
                <CircularProgress />
              </Box>
            ) : (
              <Box
                sx={{
                  height: "100vh",
                  overflow: "auto",
                  padding: "0 40px",
                }}
              >
                <Box sx={styles.BoxExitModal}>
                  <IconButton>
                    <ArrowForwardIosOutlined
                      sx={{ fontSize: "20px" }}
                      onClick={closeModal}
                    />
                  </IconButton>
                </Box>
                <Box sx={{ padding: "20px 0", mt: 3 }}>
                  <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
                    Criar novo {isOs ? "OS" : "atendimento"}
                  </Typography>
                </Box>
                <EditTicketComponentIxc
                  clientes={clientes}
                  loadingServicos={loadingServicos}
                  loadingCreateTicket={loadingCreateTicket}
                  loadingParams={loadingParams}
                  setServicos={setServicos}
                  servicos={servicos}
                  setDataTicket={setDataTicket}
                  dataTicket={dataTicket}
                  error={error}
                  logins={logins}
                  filiais={filiais}
                  departamentos={departamentos}
                  setores={setores}
                  assuntos={assuntos}
                  status={status}
                  statusOs={statusOs}
                  prioridades={prioridades}
                  prioridadesOs={prioridadesOs}
                  horarios={horarios}
                  loadingLogins={loadingLogins}
                  isEdit={false}
                  isOs={isOs}
                />
                <Box sx={styles.containerButton}>
                  <Button
                    disabled={loadingCreateTicket}
                    onClick={handleCloseConfirmation}
                    size="small"
                  >
                    Cancelar
                  </Button>
                  <LoadingButton
                    onClick={() => (isOs ? createOs() : createTicket())}
                    size="small"
                    loading={loadingCreateTicket}
                    variant="contained"
                  >
                    Salvar
                  </LoadingButton>
                </Box>
              </Box>
            )}

            {!!snackbar && (
              <Snackbar
                open
                onClose={() => setSnackbar(null)}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                <Alert {...snackbar} onClose={() => setSnackbar(null)} />
              </Snackbar>
            )}
          </Box>
        </Drawer>
      )}
      <InternoModalConfirmacaoSaida
        openConfirmacao={confirmacaoSaidaPagina}
        confirmLoad={false}
        setOpenConfirmacao={setConfirmacaoSaidaPagina}
        execute={closeModal}
        cancel={handleCancelNavigation}
        severity={"warning"}
        title={"Atenção"}
        contentText={
          "As alterações não salvas serão perdidas, deseja continuar?"
        }
        headerText={"Você está prestes a sair do modo de edição."}
        confirmText={"Continuar"}
      />
    </>
  );
}
